import {colors} from 'shells/colors/colors';

import type {SocialPlatform} from 'nutshell-graphql-types';

export const SOCIAL_PLATFORM_TO_ICON_NAME: Record<SocialPlatform, string> = {
    FACEBOOK: 'facebook',
    TWITTER: 'twitter',
    X: 'twitter',
    LINKEDIN: 'linkedin',
    FOURSQUARE: 'foursquare',
    PINTEREST: 'pinterest',
    YOUTUBE: 'youtube',
    FLICKR: 'flickr',
    VIMEO: 'vimeo-square',
    GOOGLE_PLUS: 'google-plus',
    TUMBLR: 'tumblr',
    DRIBBLE: 'dribble',
    ANGELLIST: 'angellist',
    BEHANCE: 'behance',
    DELICIOUS: 'delicious',
    DIGG: 'digg',
    GITHUB: 'github',
    HACKER_NEWS: 'hacker-news',
    INSTAGRAM: 'instagram',
    LASTFM: 'lastfm',
    REDDIT: 'reddit',
    TWITCH: 'twitch',
    VINE: 'vine',
};

export const SOCIAL_PLATFORM_TO_ICON_COLOR: Record<SocialPlatform, string> = {
    FACEBOOK: colors.socialFacebook,
    TWITTER: colors.socialTwitter,
    X: colors.socialX,
    LINKEDIN: colors.socialLinkedin,
    FOURSQUARE: colors.socialFoursquare,
    PINTEREST: colors.socialPinterest,
    YOUTUBE: colors.socialYoutube,
    FLICKR: colors.socialFlickr,
    VIMEO: colors.socialVimeo,
    GOOGLE_PLUS: colors.socialGooglePlus,
    TUMBLR: colors.socialTumblr,
    DRIBBLE: colors.socialDribbble,
    ANGELLIST: colors.socialAngelList,
    BEHANCE: colors.socialBehance,
    DELICIOUS: colors.socialDelicious,
    DIGG: colors.socialDigg,
    GITHUB: colors.socialGithub,
    HACKER_NEWS: colors.socialHackerNews,
    INSTAGRAM: colors.socialInstagram,
    LASTFM: colors.socialLastfm,
    REDDIT: colors.socialReddit,
    TWITCH: colors.socialTwitch,
    VINE: colors.socialVine,
};

export const AVATAR_SIZE = 32;
export const ICON_SIZE = 20;
export const ICON_BACKGROUND_COLOR = colors.offWhiteDk;
